import type { Message } from "../types";

/**
 * Messages exchanged with each persona.
 *
 * This is the rail's only signal, and it is free: ChatView already holds the
 * whole session's messages in order to filter them for the transcript, so this
 * is one pass over an array that is already in memory — no endpoint, no
 * column, no migration.
 *
 * Seeding from `personaIds` matters because a persona with no messages must
 * render a zero, not an empty slot; an absent value would silently blank the
 * row instead.
 */
export function messageCountsByPersona(
  messages: Message[],
  personaIds: string[] = [],
): Record<string, number> {
  const counts: Record<string, number> = {};
  personaIds.forEach((id) => {
    counts[id] = 0;
  });
  messages.forEach((m) => {
    if (!m.personaId) return;
    counts[m.personaId] = (counts[m.personaId] ?? 0) + 1;
  });
  return counts;
}
